export default __webpack_public_path__ + "static/media/image17.dfc77571.png";